/** Optional visitor answer, separate from observed URL/referrer attribution. */
export const DISCOVERY_SOURCES = [
  { value: "google_search", label: "Google Search" },
  { value: "google_maps", label: "Google Maps" },
  { value: "chatgpt", label: "ChatGPT" },
  { value: "perplexity", label: "Perplexity" },
  { value: "other_ai", label: "Another AI assistant" },
  { value: "referral", label: "Referral" },
  { value: "social_media", label: "Social media" },
  { value: "other", label: "Other" },
] as const;

export type DiscoverySource = (typeof DISCOVERY_SOURCES)[number]["value"];

/** Ignore absent or unrecognized answers; never infer one from a referrer. */
export function normalizeDiscoverySource(value: unknown): DiscoverySource | undefined {
  return DISCOVERY_SOURCES.find((source) => source.value === value)?.value;
}

export function discoverySourceLabel(value: unknown): string {
  return DISCOVERY_SOURCES.find((source) => source.value === value)?.label ?? "Not provided";
}
